import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-quan-o",
  "use": "icon-ib-quan-o-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-quan-o\">\r\n    <path d=\"M512 65.981C266.081 65.981 65.981 266.076 65.981 512c0 245.955 200.064 446.019 446.019 446.019S958.019 757.955 958.019 512c0-245.919-200.064-446.019-446.019-446.019z m0 828.038c-210.657 0-382.019-171.392-382.019-382.019 0-210.657 171.362-382.019 382.019-382.019 210.627 0 382.019 171.362 382.019 382.019 0 210.627-171.392 382.019-382.019 382.019z\" p-id=\"22103\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol